import * as React from 'react';
import { Field } from '@teamsnap/teamsnap-ui';
import { chunk } from 'lodash';
import './division-rules.scss';
import { SeasonGuideContext } from './season-guide';

export const DIVISION_GENDERS = [
  { id: 'Boys', label: 'Boys Divisions' },
  { id: 'Girls', label: 'Girls Divisions' },
  { id: 'Men', label: 'Men Division' },
  { id: 'Women', label: 'Women Divisions' },
  { id: 'Male', label: 'Male Division' },
  { id: 'Female', label: 'Female Division' },
  { id: 'Coed', label: 'Co-ed Divisions' },
];

const commonFieldStyles = {
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
};

const YesNoRadios = ({ name, checked, onClick }: { name: string; checked: boolean; onClick: (x: boolean) => void }) => (
  <div className="division-rules-radios-wrapper">
    <Field
      style={{ marginRight: '120px', ...commonFieldStyles }}
      data-testid={`${name}-yes`}
      id={`${name}-yes`}
      type="radio"
      name={name}
      label="Yes"
      formFieldProps={{
        checked: checked,
        onClick: () => onClick(true),
      }}
    />

    <Field
      style={{ ...commonFieldStyles }}
      data-testid={`${name}-no`}
      id={`${name}-no`}
      type="radio"
      name={name}
      label="No"
      formFieldProps={{
        checked: checked === false,
        onClick: () => onClick(false),
      }}
    />
  </div>
);

const DivisionRules = () => {
  const { season, setSeason } = React.useContext(SeasonGuideContext);
  const { organizeMultipleDivisions, organizeDivisionsByAge, organizeDivisionsByGender, genders } = season;

  return (
    <>
      <h2 className="u-spaceBottomLg">Do you organize your teams in more than 1 division?</h2>
      <YesNoRadios
        name="organizeMultipleDivisions"
        checked={organizeMultipleDivisions}
        onClick={(x) =>
          x === true
            ? setSeason({ organizeMultipleDivisions: x })
            : setSeason({
                organizeMultipleDivisions: x,
                organizeDivisionsByAge: null,
                organizeDivisionsByGender: null,
                genders: [],
              })
        }
      />

      {organizeMultipleDivisions && (
        <>
          <h2 className="u-spaceEndsLg u-padTopLg">Does this program organize divisions by age group?</h2>
          <YesNoRadios
            name="organizeDivisionsByAge"
            checked={organizeDivisionsByAge}
            onClick={(x) => setSeason({ organizeDivisionsByAge: x })}
          />
        </>
      )}

      {organizeMultipleDivisions && (
        <>
          <h2 className="u-spaceEndsLg u-padTopLg">Does this program organize divisions by gender?</h2>
          <YesNoRadios
            name="organizeDivisionsByGender"
            checked={organizeDivisionsByGender}
            onClick={(x) => setSeason({ organizeDivisionsByGender: x })}
          />

          {organizeDivisionsByGender &&
            chunk(DIVISION_GENDERS, 2).map((row, index) => (
              <div className="division-rules-genders-row" key={index}>
                {row.map((gender) => (
                  <Field
                    data-testid={`gender-option-${gender.id}`}
                    type="checkbox"
                    name={gender.id}
                    formFieldProps={{
                      text: gender.label,
                      checked: genders.includes(gender.id),
                      onClick: () => {
                        setSeason({
                          genders: genders.includes(gender.id)
                            ? genders.filter((x) => x !== gender.id)
                            : [...genders, gender.id],
                        });
                      },
                    }}
                  />
                ))}
              </div>
            ))}
        </>
      )}
    </>
  );
};

export default DivisionRules;
